// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AgeVerificationBanner-module-description-3-9Iy{margin-top:17px;margin-bottom:17px}.AgeVerificationBanner-module-description-3-9Iy.AgeVerificationBanner-module-successDescription-4fMRx{margin-top:0}.AgeVerificationBanner-module-warningLink-CI5y7{text-decoration:none;font-weight:var(--weight-medium);color:#3567ff}.AgeVerificationBanner-module-warningLink-CI5y7:hover{text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "AgeVerificationBanner-module-description-3-9Iy",
	"successDescription": "AgeVerificationBanner-module-successDescription-4fMRx",
	"warningLink": "AgeVerificationBanner-module-warningLink-CI5y7"
};
export default ___CSS_LOADER_EXPORT___;
